document.addEventListener("DOMContentLoaded", () => {

  const mapElement = document.getElementById("map");
    if (mapElement) {
      initMap();
      
  }
  animateUI();
  customCursor();
  animateIntro();
  hideAllEfforts();
  createSectionTimelines();
  initNav();
  initObserver();
  initPolaroids();
  // animateOutro();
});
